/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { Alert } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { dismissAlert } from '../../redux/alerts/alertsActions';
import { ALERT_DISMISS, ALERT_SHOW } from '../../redux/alerts/alertActionTypes';

function DokanAlert() {
    const alert = useSelector((state) => state.alert);
    const dispatch = useDispatch();

    return (
        <>
            {alert.showAlert && (
                <div>
                    <Alert
                        message={alert.alertMeta.message}
                        type={alert.alertType}
                        closable
                        showIcon
                        afterClose={() =>
                            dispatch({ type: ALERT_DISMISS, payload: { showAlert: false } })
                        }
                    />
                </div>
            )}
        </>
    );
}

export default DokanAlert;
